import { uuid } from '@/package';

import type { CreateLabelItemParameter, LabelItem } from './type';

export const createLabelItem = <T extends string>(
  param: CreateLabelItemParameter<T>,
): LabelItem<T> => {
  return {
    disabled: false,
    confidence: {
      default: 0.65,
      max: 0.9,
      min: 0.2,
    },
    ...param,
    name: param.name ?? param.value,
    id: uuid(),
  };
};
